/**
 * @license
 * Copyright (c) Peculiar Ventures, LLC.
 *
 * This source code is licensed under the BSD 3-Clause license found in the
 * LICENSE file in the root directory of this source tree.
 */

import {
  FunctionalComponent, h, VNode,
} from '@stencil/core';
import { Typography } from '@peculiar/certificates-viewer';

export interface IFortifyButtonProps {
  href?: string;
  class?: string;
  startIcon?: VNode;
  disabled?: boolean;
  variant?: 'default' | 'secondary' | 'primary';
  type?: 'button' | 'submit';
  onClick?: (event: MouseEvent) => void;
  ref?: (elm?: HTMLElement) => void;
}

export const FortifyButton: FunctionalComponent<IFortifyButtonProps> = (props, children) => {
  const {
    href,
    class: classProp,
    startIcon,
    disabled,
    variant = 'secondary',
    type = 'button',
    onClick,
    ref,
  } = props;

  const isLink = !!href;
  const TagType = isLink ? 'a' : 'button';

  return (
    <TagType
      ref={ref}
      type={!isLink && type}
      href={isLink && href}
      target={isLink && '_blank'}
      rel={isLink && 'noreferrer noopener'}
      class={{
        button: true,
        [`button_${variant}`]: true,
        [classProp]: Boolean(classProp),
      }}
      disabled={disabled}
      onClick={onClick}
    >
      {startIcon}
      <Typography
        variant="btn1"
        component="span"
        class="button_child_text"
      >
        {children}
      </Typography>
    </TagType>
  );
};
